import { ChangeDetectionStrategy, Component, computed, effect, input, model, untracked } from '@angular/core';
import { TimeSlotGroup, TimeSlotIntervalTypes, TimeSlotOption } from '@checkout-v2/const';
import { ItemWrapperComponent } from '../item-wrapper';
import { ExactlyInTimeComponent } from './exactly-in-time';

@Component({
  selector: 'sd-time-slot-options',
  imports: [ItemWrapperComponent, ExactlyInTimeComponent],
  templateUrl: './time-slot-options.component.html',
  styleUrl: './time-slot-options.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSlotOptionsComponent {
  readonly selectedGroup = input.required<TimeSlotGroup>();
  readonly selectedOption = model.required<TimeSlotOption | undefined>();

  private readonly firstOption = computed(() => this.selectedGroup().options[0]);

  protected readonly timeSlotIntervalTypes = TimeSlotIntervalTypes;
  protected readonly currentGroupIntervalType = computed(() => this.firstOption().interval.type);

  constructor() {
    // если выбрана срочная доставка, то сразу же проставляем
    // выбранным единственный элемент из списка options
    effect(() => {
      const currentGroupIntervalType = this.currentGroupIntervalType();

      if (currentGroupIntervalType === this.timeSlotIntervalTypes.Express) {
        untracked(() => this.onSelectOption(this.firstOption()));
      }
    });
  }

  onSelectOption(option: TimeSlotOption): void {
    this.selectedOption.set(option);
  }
}
